/**
 * @generated SignedSource<<07f5fa2dd4ac2965fc20b685e2c28f61>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type GetVideoDataV2Input = {
  clientMutationId?: string | null | undefined;
  vimeoId: string;
  vimeoVideoSourceId: string;
};
export type VideoSourceField_GetVideoDataV2Mutation$variables = {
  input: GetVideoDataV2Input;
};
export type VideoSourceField_GetVideoDataV2Mutation$data = {
  readonly Admin: {
    readonly ElearningV2: {
      readonly getVideoData: {
        readonly videoData: {
          readonly duration: number;
          readonly name: string;
          readonly thumbnailUrl: string;
        } | null | undefined;
      } | null | undefined;
    };
  };
};
export type VideoSourceField_GetVideoDataV2Mutation = {
  response: VideoSourceField_GetVideoDataV2Mutation$data;
  variables: VideoSourceField_GetVideoDataV2Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "AdminMutationType",
    "kind": "LinkedField",
    "name": "Admin",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ElearningV2AdminMutationSchema",
        "kind": "LinkedField",
        "name": "ElearningV2",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "input",
                "variableName": "input"
              }
            ],
            "concreteType": "GetVideoDataV2Payload",
            "kind": "LinkedField",
            "name": "getVideoData",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "VideoDataV2",
                "kind": "LinkedField",
                "name": "videoData",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "duration",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "thumbnailUrl",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "VideoSourceField_GetVideoDataV2Mutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "VideoSourceField_GetVideoDataV2Mutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "6f56561a780cb5865244398eeeb25c1b",
    "id": null,
    "metadata": {},
    "name": "VideoSourceField_GetVideoDataV2Mutation",
    "operationKind": "mutation",
    "text": "mutation VideoSourceField_GetVideoDataV2Mutation(\n  $input: GetVideoDataV2Input!\n) {\n  Admin {\n    ElearningV2 {\n      getVideoData(input: $input) {\n        videoData {\n          name\n          duration\n          thumbnailUrl\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "03e38a963c220872e0f53914c677d0a7";

export default node;
